<template>
    <div id="modal-apply-status-set" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="custom-control custom-switch mb-3">
                       <input type="checkbox" v-model="procFlg" class="custom-control-input" id="proc-flg" name="proc-flg">
                       <label class="custom-control-label" for="proc-flg">
                           <span v-if="procFlg"> Open </span>
                           <span v-else> Closed </span>
                       </label>
                    </div>
                    <div class="d-flex mb-2">
                        <div class="custom-control custom-switch">
                           <input type="checkbox" v-model="pjSee" class="custom-control-input" :disabled="pjDisable" id="pj-see" name="pj-see">
                           <label class="custom-control-label" for="pj-see">
                               <span v-if="pjSee"> 案件側可視 </span>
                               <span v-else> 案件側不可視 </span>
                           </label>
                        </div>
                        <div class="custom-control custom-switch ml-auto">
                           <input type="checkbox" v-model="teSee" class="custom-control-input" :disabled="teDisable" id="te-see" name="te-see">
                           <label class="custom-control-label" for="te-see">
                               <span v-if="teSee"> 要員側可視 </span>
                               <span v-else> 要員側不可視 </span>
                           </label>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="mb-2 mr-1 w-50">
                            <div class="text-nowrap"> 応募状況(案件側)</div>
                            <input v-model.trim="item.pj_ap_flg"  class="form-control" spellcheck=false>
                        </div>
                        <div class="mb-2 w-50">
                            <div class="text-nowrap">応募状況(要員側)</div>
                            <input v-model.trim="item.te_ap_flg"  class="form-control" spellcheck=false>
                        </div>
                    </div>
                    <div class="mb-2">
                        <div class="text-nowrap">
                            応募状況(管理側)&nbsp;
                            <span class="btn btn-link py-0" @click="copyApFlgToPj">案件へ</span>
                            <span class="btn btn-link py-0 px-0" @click="copyApFlgToTe">要員へ</span>
                        </div>
                        <select v-model="item.sys_ap_flg" class="form-control px-1" @change="changeSysApFlg">
                            <option v-for="(op,index) in sysApFlgList" :value='op.val' :key="index">{{op.lab}}</option>
                        </select>
                    </div>
                    <div v-show="hasCancel" class="mb-2">
                        <div class="text-nowrap">キャセル状態</div>
                        <select v-model.trim="item.is_cancel" class="form-control px-1 mb-2" @change="changeCancel">
                            <option :value="null">--選択--</option>
                            <option value='1'>正常取消</option>
                            <option value='2'>要員異常</option>
                            <option value='3'>案件異常</option>
                        </select>
                        <div class="text-nowrap">キャセル理由</div>
                        <div class="d-flex">
                            <select v-model.trim="cancelReason" class="form-control px-1 mr-2" @change="changeCancelReasonList">
                                <option value="">--選択--</option>
                                <option value='案件辞退'>案件辞退</option>
                                <option value='平行優先'>平行優先</option>
                                <option value='他決済み'>他決済み</option>
                                <option value='案件充足'>案件充足</option>
                                <option value='提案競合'>提案競合</option>
                                <option value='返事なし'>返事なし</option>
                                <option value='トラブル'>トラブル</option>
                            </select>
                            <input v-model.trim="item.cancel_reason"  class="form-control" spellcheck=false>
                        </div>
                    </div>
                    <div class="mb-2">
                        <div class="text-nowrap">面接</div>
                        <select v-model.trim="item.intv_type" class="form-control px-1" @change='changeIntvType'>
                            <option :value="null">--選択--</option>
                            <option value='0'>現地</option>
                            <option value='1'>Web</option>
                        </select>
                    </div>
                    <div v-if="hasIntv" class="d-flex">
                        <div class="container mr-1">
                            <div class="row">
                                <div class="col p-0">
                                    <div>案件側日程</div>
                                    <select v-model.trim="item.pj_intv_d" class="form-control mb-2">
                                        <option :value="null">--選択--</option>
                                        <option v-for="(op,index) in intvDayList" :value='op' :key="index">{{ op | dformatw }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 p-0">
                                    <select v-model.trim="item.pj_intv_h" class="form-control">
                                        <option :value="null">--</option>
                                        <option v-for="(n,index) in 24" :key="index" :value="addZero(n)" :selected="n == 12">{{n}}時</option>
                                    </select>
                                </div>
                                <div class="col-6 p-0 pl-1">
                                    <select v-model.trim="item.pj_intv_m" class="form-control">
                                        <option :value="null">--</option>
                                        <option v-for="(n,index) in 60" :key="index" :value="addZero(n-1)" :selected="n == 31">{{n-1}}分</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="container mb-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div>要員側日程</div>
                                    <select v-model.trim="item.te_intv_d" class="form-control mb-2">
                                        <option :value="null">--選択--</option>
                                        <option v-for="(op,index) in intvDayList" :value='op' :key="index">{{ op | dformatw }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 p-0">
                                    <select v-model.trim="item.te_intv_h" class="form-control">
                                        <option :value="null">--</option>
                                        <option v-for="(n,index) in 24" :key="index" :value="addZero(n)" :selected="n == 12">{{n}}時</option>
                                    </select>
                                </div>
                                <div class="col-6 p-0 pl-1">
                                    <select v-model.trim="item.te_intv_m" class="form-control">
                                        <option :value="null">--</option>
                                        <option v-for="(n,index) in 60" :key="index" :value="addZero(n-1)" :selected="n == 31">{{n-1}}分</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        備考 ({{noteLen}}/1000)
                        <textarea v-model.trim="item.sys_note" class="form-control" rows="2" spellcheck=false  maxlength="1000"></textarea>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger" type="button" @click="saveApplyStatus">
                        設定する
                    </button>
                    <button class="btn btn-success" type="button" @click="hideThis">
                        &nbsp;&nbsp;閉じる&nbsp;&nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    props: {
        teDisable:{
            type: Boolean,
            default : false
        },
        pjDisable:{
            type: Boolean,
            default : false
        }
    },
    mounted () {
        this.makeIntvDayList()
        this.getSysApFlgList()
    },
    data () {
        return {
            item: {},
            procFlg: true,
            pjSee: true,
            teSee: true,
            cancelReason: '',
            sysApFlgList: [],
            intvDayList: [],
        }
    },
    watch: {
        getSaveApplyStatusDetailStatus (status) {
            if (status == '1') {
                this.$store.dispatch('startSpinner')
            }
            if (status == '2') {
                this.hideThis()
                this.$store.dispatch('doneSpinner')
            }
            if (status == '3') {
                this.$store.dispatch('startSpinner')
            }
        }
    },
    computed: {
        hasCancel () {
            return this.item.sys_ap_flg == '60' ? true : false
        },
        hasIntv () {
            return this.item.intv_type ? true : false
        },
        noteLen () {
            return this.item.sys_note ? this.item.sys_note.length : 0
        },
        ...mapGetters(['getSaveApplyStatusDetailStatus'])
    },
    methods: {
        makeIntvDayList () {
            for (let i=0; i < 120; i++) {
                this.intvDayList.push(this.$moment(new Date).add(i,'days').format('YYYYMMDD'))
            }
        },
        getSysApFlgList () {
            this.sysApFlgList = this.$parent.getList('sys_ap_flg')
        },
        copyApFlgToPj () {
            let flg = this.$parent.converVal('sys_ap_flg', this.item.sys_ap_flg)
            this.item.pj_ap_flg = flg
        },
        copyApFlgToTe () {
            let flg = this.$parent.converVal('sys_ap_flg', this.item.sys_ap_flg)
            this.item.te_ap_flg = flg
        },
        changeSysApFlg () {
            if (this.item.sys_ap_flg != '60') {
                this.item.is_cancel = null
                this.item.cancel_reason = null
                this.cancelReason = ''
            }
        },
        changeCancel () {
            if (this.item.is_cancel == null) {
                this.item.cancel_reason = null
                this.cancelReason = ''
            }
        },
        changeCancelReasonList () {
            this.item.cancel_reason = this.cancelReason
        },
        changeIntvType () {
            if (this.item.intv_type == null) {
                this.item.pj_intv_d = null
                this.item.pj_intv_h = null
                this.item.pj_intv_m = null
                this.item.te_intv_d = null
                this.item.te_intv_h = null
                this.item.te_intv_m = null
            }
        },
        openThis (item) {
            this.item = item
            this.procFlg = this.item.proc_flg == '0' ? true : false
            this.pjSee = this.item.pj_see == '0' ? false : true
            this.teSee = this.item.te_see == '0' ? false : true
            $('#modal-apply-status-set').modal('show')
        },
        hideThis () {
            this.resetThis()
            $('#modal-apply-status-set').modal('hide')
        },
        resetThis () {
            this.item = {}
            this.procFlg = true
            this.pjSee = true
            this.teSee = true
            this.cancelReason = ''
        },
        saveApplyStatus () {
            this.item.proc_flg = this.procFlg ? '0' : '1'
            this.item.pj_see = this.pjSee ? '1' : '0'
            this.item.te_see = this.teSee ? '1' : '0'

            this.$store.dispatch('saveApplyStatus', {
                item: this.item,
            })
        },
        addZero (data) {
            return ('00' + data).slice(-2)
        },
    }
}
</script>

<style>

</style>
